// extracted by mini-css-extract-plugin
export default {"property":"modal_property__SArOC","btn":"modal_btn__eNl4a","input":"modal_input__xU-Y4","inputs":"modal_inputs__aEm0r"};